import { useQuery } from '@tanstack/react-query';
import { dashboardApi, type DashboardPeriod } from 'shared/services/dashboardApi';
import { queryKeys } from '../queryConfig';

export const useSuperAdminDashboard = (period: DashboardPeriod = 'all') => {
  return useQuery({
    queryKey: queryKeys.dashboard.superAdmin(period),
    queryFn: () => dashboardApi.getSuperAdmin(period),
    // The previous 15-min staleTime + `refetchOnMount: false` made the
    // /inicio, /en-proceso and /resumen cards visibly stale: creating a
    // permit/ficha/verification then navigating back showed the OLD counts
    // until a full page reload (cache held for up to 15 min). Tighten the
    // window and force a fetch on every mount so the counts match recent
    // activity. The endpoint is a single aggregate call, so the cost of
    // re-fetching on every navigation back is negligible. gcTime stays
    // generous to preserve the cache between quick unmount/remount cycles
    // (e.g. drawer open/close).
    staleTime: 30 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
};
